/** Merge these keys under presentations.copyToProject in each locale. */
export const copyToProjectCopy = {
  en: {
    action: 'Copy to another Project',
    title: 'Copy to another Project',
    description:
      'Prepare a copy of “{{name}}” in a different Project of this company. Nothing is copied until you review and approve the proposal. The original stays unchanged.',
    destination: 'Destination Project',
    destinationPlaceholder: 'Choose a Project',
    destinationLoading: 'Loading Projects…',
    search: 'Search Projects',
    noMatch: 'No Project matches that search.',
    showMore: 'Show more Projects',
    destinationEmpty: 'There is no other Project where you can create presentations.',
    destinationError: 'Projects could not be loaded. Try again.',
    name: 'New presentation name',
    check: 'Check compatibility',
    checking: 'Checking…',
    back: 'Back',
    summary: 'Copy {{count}} slides into “{{project}}” as a draft.',
    blockersTitle: 'This copy cannot be created yet',
    warningsTitle: 'Review before copying',
    acknowledge: 'I have reviewed these notes and want to continue.',
    remapTitle: 'Replace media from the original Project',
    remapHelp:
      'These files belong to the original Project. Choose an existing file in the destination, or in the company library, to use instead.',
    remapItem: 'File {{index}} of {{count}}',
    remapChoose: 'Choose replacement',
    remapChange: 'Change replacement',
    remapChosen: 'Replacement chosen',
    remapNeeded: 'Replacement needed',
    inaccessible: '{{count}} file(s) are not available to you and block this copy.',
    copied: 'Copied: slides, order, chapters, content, settings, scripts, cues and appearance.',
    omitted:
      'Not copied: published releases, share links, analytics, access grants and generated audio.',
    confirm: 'Prepare for review',
    pending: 'Preparing…',
    success: 'Copy proposal prepared. Review it before anything is copied.',
    appearanceChoice:
      'Use the destination Project’s theme. Inherited appearance will resolve under that theme and may look different.',
    reviewNote:
      'This prepares an immutable proposal. A new draft is created only after you approve it on the review page.',
    blockers: {
      CLASSIFICATION_DOWNGRADE_FORBIDDEN:
        'The destination Project is less restricted than the original. Copies can only go to an equally or more restricted Project.',
      DESTINATION_MUST_DIFFER_USE_DUPLICATE:
        'Choose a different Project, or use Duplicate to copy within this one.',
      DESTINATION_PROJECT_ARCHIVED:
        'The destination Project is archived and cannot receive new presentations.',
      COPY_EXECUTION_DISABLED:
        'Copying between Projects is not enabled for this workspace yet. Ask an owner.',
      TEMPLATE_VERSION_INCOMPATIBLE:
        'A template used by this presentation is not allowed in the destination Project.',
      ASSET_UNAVAILABLE: 'A file used by this presentation is not available to you.',
      ASSET_REMAP_REQUIRED_OR_INVALID:
        'Some files must be replaced with files available in the destination.',
      ASSET_MAPPING_NOT_REFERENCED: 'A chosen replacement no longer matches this presentation.',
      DYNAMIC_TEMPLATE_STATIC_MEDIA_REVIEW_REQUIRED:
        'A custom HTML template may contain built-in media that cannot be moved safely. Copy is blocked.',
      TEMPLATE_ASSET_INSPECTION_INCOMPLETE:
        'The presentation could not be fully inspected, so copying is blocked.',
      COMPOSITION_UNREADABLE:
        'A slide’s component layout is invalid or uses an unsupported version, so copying is blocked.',
      COMPOSITION_LINK_UNRESOLVABLE:
        'A component link points to a slide that is not in this presentation, so copying is blocked.',
    },
    warnings: {
      PRIVATE_PRESENTER_DATA_OMITTED: 'Presenter notes and scripts will not be copied.',
      DESTINATION_THEME_APPLIES_APPEARANCE_MAY_DIFFER:
        'The destination Project’s theme applies, so the copy may look different.',
      SMART_MORPH_CROSS_SLIDE_REFERENCE_REVIEW_REQUIRED:
        'Review Smart Morph transitions in the copy after it is created.',
    },
    errors: {
      default: 'Could not copy this presentation.',
      ACCESS_DENIED: 'You do not have permission to copy into that Project.',
      PROJECT_NOT_FOUND: 'That Project is not available.',
      PRESENTATION_NOT_FOUND: 'This presentation is not available.',
      PRESENTATION_CONFLICT: 'The presentation changed. Check compatibility again.',
      PROJECT_CONFLICT: 'The destination Project changed. Check compatibility again.',
      PRESENTATION_COPY_BLOCKED: 'The copy is blocked. Check compatibility again.',
      COPY_EXECUTION_DISABLED:
        'Copying between Projects is not enabled for this workspace yet. Ask an owner.',
      VALIDATION_FAILED: 'Check the name and Project, then try again.',
    },
  },
  fa: {
    action: 'کپی به پروژه دیگر',
    title: 'کپی به پروژه دیگر',
    description:
      'یک نسخه پیش‌نویس مستقل از «{{name}}» را در پروژه‌ای دیگر از همین شرکت بسازید. نسخه اصلی بدون تغییر می‌ماند.',
    destination: 'پروژه مقصد',
    destinationPlaceholder: 'یک پروژه انتخاب کنید',
    destinationLoading: 'در حال بارگذاری پروژه‌ها…',
    search: 'جست‌وجوی پروژه',
    noMatch: 'پروژه‌ای با این جست‌وجو پیدا نشد.',
    showMore: 'نمایش پروژه‌های بیشتر',
    destinationEmpty: 'پروژه دیگری که بتوانید در آن ارائه بسازید وجود ندارد.',
    destinationError: 'بارگذاری پروژه‌ها ناموفق بود. دوباره تلاش کنید.',
    name: 'نام ارائه جدید',
    check: 'بررسی سازگاری',
    checking: 'در حال بررسی…',
    back: 'بازگشت',
    summary: '{{count}} اسلاید به‌صورت پیش‌نویس در «{{project}}» کپی می‌شود.',
    blockersTitle: 'این کپی هنوز ممکن نیست',
    warningsTitle: 'پیش از کپی بررسی کنید',
    acknowledge: 'این نکته‌ها را بررسی کرده‌ام و می‌خواهم ادامه دهم.',
    remapTitle: 'جایگزینی رسانه‌های پروژه اصلی',
    remapHelp:
      'این فایل‌ها متعلق به پروژه اصلی هستند. یک فایل موجود در مقصد یا کتابخانه شرکت را برای جایگزینی انتخاب کنید.',
    remapItem: 'فایل {{index}} از {{count}}',
    remapChoose: 'انتخاب جایگزین',
    remapChange: 'تغییر جایگزین',
    remapChosen: 'جایگزین انتخاب شد',
    remapNeeded: 'جایگزین لازم است',
    inaccessible: '{{count}} فایل در دسترس شما نیست و مانع این کپی است.',
    copied: 'کپی می‌شود: اسلایدها، ترتیب، فصل‌ها، محتوا، تنظیمات، متن‌ها، نشانه‌ها و ظاهر.',
    omitted: 'کپی نمی‌شود: انتشارها، پیوندهای اشتراک، آمار، دسترسی‌ها و صدای تولیدشده.',
    confirm: 'آماده‌سازی برای بازبینی',
    pending: 'در حال آماده‌سازی…',
    success: 'پیشنهاد کپی آماده شد. پیش از هر کپی آن را بازبینی کنید.',
    appearanceChoice:
      'از تم پروژه مقصد استفاده شود. ظاهر ارث‌بری‌شده تحت آن تم محاسبه می‌شود و ممکن است متفاوت باشد.',
    reviewNote:
      'این کار یک پیشنهاد تغییرناپذیر می‌سازد. پیش‌نویس جدید فقط پس از تأیید شما در صفحه بازبینی ساخته می‌شود.',
    blockers: {
      CLASSIFICATION_DOWNGRADE_FORBIDDEN:
        'پروژه مقصد کمتر از پروژه اصلی محدود است. کپی فقط به پروژه‌ای با محدودیت برابر یا بیشتر ممکن است.',
      DESTINATION_MUST_DIFFER_USE_DUPLICATE:
        'پروژه دیگری انتخاب کنید یا برای کپی در همین پروژه از تکثیر استفاده کنید.',
      DESTINATION_PROJECT_ARCHIVED: 'پروژه مقصد بایگانی شده و ارائه جدید نمی‌پذیرد.',
      COPY_EXECUTION_DISABLED:
        'کپی بین پروژه‌ها هنوز برای این فضای کاری فعال نشده است. از مالک بخواهید.',
      TEMPLATE_VERSION_INCOMPATIBLE: 'یکی از قالب‌های این ارائه در پروژه مقصد مجاز نیست.',
      ASSET_UNAVAILABLE: 'یکی از فایل‌های این ارائه برای شما در دسترس نیست.',
      ASSET_REMAP_REQUIRED_OR_INVALID: 'برخی فایل‌ها باید با فایل‌های موجود در مقصد جایگزین شوند.',
      ASSET_MAPPING_NOT_REFERENCED: 'جایگزین انتخاب‌شده دیگر با این ارائه مطابقت ندارد.',
      DYNAMIC_TEMPLATE_STATIC_MEDIA_REVIEW_REQUIRED:
        'یک قالب HTML سفارشی ممکن است رسانه داخلی داشته باشد که به‌صورت امن منتقل نمی‌شود. کپی مسدود است.',
      TEMPLATE_ASSET_INSPECTION_INCOMPLETE: 'ارائه به‌طور کامل بررسی نشد، پس کپی مسدود است.',
      COMPOSITION_UNREADABLE:
        'چیدمان مولفه یک اسلاید نامعتبر است یا نسخه پشتیبانی‌نشده دارد، پس کپی مسدود است.',
      COMPOSITION_LINK_UNRESOLVABLE:
        'پیوند یک مولفه به اسلایدی خارج از این ارائه اشاره می‌کند، پس کپی مسدود است.',
    },
    warnings: {
      PRIVATE_PRESENTER_DATA_OMITTED: 'یادداشت‌ها و متن‌های ارائه‌دهنده کپی نمی‌شوند.',
      DESTINATION_THEME_APPLIES_APPEARANCE_MAY_DIFFER:
        'تم پروژه مقصد اعمال می‌شود، پس ظاهر نسخه کپی ممکن است متفاوت باشد.',
      SMART_MORPH_CROSS_SLIDE_REFERENCE_REVIEW_REQUIRED:
        'پس از ساخت، انتقال‌های هوشمند را در نسخه کپی بررسی کنید.',
    },
    errors: {
      default: 'کپی ارائه ناموفق بود.',
      ACCESS_DENIED: 'مجوز کپی در آن پروژه را ندارید.',
      PROJECT_NOT_FOUND: 'آن پروژه در دسترس نیست.',
      PRESENTATION_NOT_FOUND: 'این ارائه در دسترس نیست.',
      PRESENTATION_CONFLICT: 'ارائه تغییر کرده است. سازگاری را دوباره بررسی کنید.',
      PROJECT_CONFLICT: 'پروژه مقصد تغییر کرده است. سازگاری را دوباره بررسی کنید.',
      PRESENTATION_COPY_BLOCKED: 'کپی مسدود است. سازگاری را دوباره بررسی کنید.',
      COPY_EXECUTION_DISABLED:
        'کپی بین پروژه‌ها هنوز برای این فضای کاری فعال نشده است. از مالک بخواهید.',
      VALIDATION_FAILED: 'نام و پروژه را بررسی کنید و دوباره تلاش کنید.',
    },
  },
} as const;
